namespace Nobox
{
    @Serenity.Decorators.registerFormatter()
    export class ChannelNmFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (ctx.value == "" || ctx.value == null) {
                return "";
            } else {
                var campaign = Master.ChannelRow.getLookup().itemById[ctx.value];
                if (campaign == undefined) {
                    return ""
                } else {
                    return `<a href="javascript:;" class="channel-link" title="${campaign["Nm"]}">${campaign["Nm"]}</a>`;
                }
            }
        }
    }
}
